var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsole1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 69.99 148.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#828282;}.cls-2{fill:#cbd5e4;}.cls-3{fill:#b8c6cf;}.cls-4{fill:#b9bdc1;}.cls-5{fill:#8ab3ff;}.cls-6{fill:#343f42;}.cls-7{fill:#588df0;}.cls-13,.cls-17,.cls-8{fill:none;}.cls-8{stroke:#588df0;}.cls-13,.cls-15,.cls-17,.cls-8{stroke-miterlimit:10;}.cls-13,.cls-8{stroke-width:0.97px;}.cls-9{fill:#303b3e;}.cls-10{fill:#f44d4d;}.cls-11{fill:#f66562;}.cls-12{fill:#d0d6e2;}.cls-13{stroke:#303b3e;}.cls-14{fill:#9caab2;}.cls-15,.cls-16{fill:#d0d6e1;}.cls-15,.cls-17{stroke:#343f42;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Console_01b",
    "data-name": "Console_01b",
    viewBox: "0 0 69.99 148.7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.35 15.13 0 135.24 23.21 148.7 23.44 70.62 9.84 20.48 0.35 15.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.85 5.77 46.9 0 0.35 15.13 9.84 20.48 56.85 5.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69.99 55.5 23.44 70.62 9.84 20.48 56.85 5.77 69.99 55.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "69.76 133.57 23.21 148.7 23.44 70.62 69.99 55.5 69.76 133.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "19.5 33.82 46.92 24.88 54.21 52.57 26.79 61.51 19.5 33.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.24,26.12,53,51.93,27.47,60.27l-6.8-25.81,25.57-8.34m1.35-2.48L18.32,33.18l7.8,29.57,29.26-9.54L47.59,23.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "37.44 33.34 46.22 30.51 50.9 48.25 42.11 51.08 37.44 33.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 22.8,
    y1: 38.1,
    x2: 34.52,
    y2: 34.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 24.37,
    y1: 44.06,
    x2: 36.08,
    y2: 40.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 25.93,
    y1: 49.97,
    x2: 37.63,
    y2: 46.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 27.48,
    y1: 55.88,
    x2: 39.19,
    y2: 52.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20,29.44a3.85,3.85,0,0,1-3.38-2.88,3.14,3.14,0,0,1,1.89-3.93,2.9,2.9,0,0,1,1-.13,3.86,3.86,0,0,1,3.37,2.88A3.14,3.14,0,0,1,21,29.31,2.88,2.88,0,0,1,20,29.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.36,25.93,20.79,24a1.85,1.85,0,0,0-1.59-.22,2.33,2.33,0,0,0-1.38,2.83,2.25,2.25,0,0,0,.83,1.26l4,2.2a1.84,1.84,0,0,0,1.42.12,2.33,2.33,0,0,0,1.38-2.83A2.22,2.22,0,0,0,24.36,25.93Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 23.49,
    cy: 27.98,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-0.77 0.67) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.82,26.61a3.86,3.86,0,0,1-3.37-2.88,3.15,3.15,0,0,1,1.88-3.93,3,3,0,0,1,1-.13,3.86,3.86,0,0,1,3.38,2.88,3.14,3.14,0,0,1-1.89,3.93A2.9,2.9,0,0,1,28.82,26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M33.15,23.1l-3.57-1.94A1.86,1.86,0,0,0,28,20.94,2.39,2.39,0,0,0,27.44,25l4,2.19a1.79,1.79,0,0,0,1.42.13,2.33,2.33,0,0,0,1.38-2.83A2.22,2.22,0,0,0,33.15,23.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 32.28,
    cy: 25.15,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-0.69 0.91) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.86,24a3.4,3.4,0,0,1-3-2.57,3,3,0,0,1,1.77-3.65,2.47,2.47,0,0,1,.89-.13,3.41,3.41,0,0,1,3,2.58,3,3,0,0,1-1.76,3.65A2.7,2.7,0,0,1,35.86,24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 35.68,
    cy: 20.85,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-0.57 1) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.71,22.13a3.4,3.4,0,0,1-3-2.57,3,3,0,0,1,1.77-3.65,2.23,2.23,0,0,1,.89-.12,3.39,3.39,0,0,1,3,2.57A3,3,0,0,1,42.61,22,2.72,2.72,0,0,1,41.71,22.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 41.54,
    cy: 18.96,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-0.51 1.17) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.57,20.25a3.42,3.42,0,0,1-3-2.58A3,3,0,0,1,46.33,14a2.63,2.63,0,0,1,.89-.12,3.4,3.4,0,0,1,3,2.57,3,3,0,0,1-1.76,3.65A2.49,2.49,0,0,1,47.57,20.25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 47.4,
    cy: 17.07,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-0.46 1.33) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.75 23.25 56.54 52.82 65.33 49.98 57.54 20.41 48.75 23.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55,30.74a3.41,3.41,0,0,1-3-2.58,3,3,0,0,1,1.77-3.65,2.7,2.7,0,0,1,.89-.12,3.39,3.39,0,0,1,3,2.57,3,3,0,0,1-1.76,3.66A2.7,2.7,0,0,1,55,30.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 54.81,
    cy: 27.56,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-0.75 1.54) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.32,39.61a3.4,3.4,0,0,1-3-2.57,3,3,0,0,1,1.77-3.66,2.63,2.63,0,0,1,.89-.12,3.4,3.4,0,0,1,3,2.57,3,3,0,0,1-1.76,3.66A2.72,2.72,0,0,1,57.32,39.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 57.15,
    cy: 36.43,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-0.99 1.61) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.66,48.48a3.39,3.39,0,0,1-3-2.57,3,3,0,0,1,1.76-3.66,2.72,2.72,0,0,1,.9-.12,3.41,3.41,0,0,1,3,2.58,3,3,0,0,1-1.77,3.65A2.66,2.66,0,0,1,59.66,48.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 59.48,
    cy: 45.31,
    rx: 2.05,
    ry: 2.29,
    transform: "translate(-1.24 1.68) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 52.93,
    y1: 33.19,
    x2: 58.79,
    y2: 31.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 55.23,
    y1: 41.9,
    x2: 61.09,
    y2: 40.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 57.6,
    y1: 50.89,
    x2: 63.46,
    y2: 49
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_2",
    "data-name": "New Symbol 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "64.16 74.45 37.56 83.09 37.45 119.13 64.05 110.49 64.16 74.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "40.87 85.02 40.9 100 47.48 97.87 47.52 82.86 40.87 85.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "50.81 93.79 50.83 111.78 60.74 108.56 60.79 90.55 50.81 93.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "40.82 103.03 40.85 115.06 47.44 112.93 47.47 100.88 40.82 103.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 60.82,
    y1: 81.54,
    x2: 50.84,
    y2: 84.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 60.81,
    y1: 84.54,
    x2: 50.83,
    y2: 87.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 60.8,
    y1: 87.54,
    x2: 50.82,
    y2: 90.79
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 69.99,
    height: 148.7,
    xlinkHref: "#Console_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole1);
export default __webpack_public_path__ + "static/media/console-1.5c0f32537e2bd56dd63e4b259b8a4678.svg";
export { ForwardRef as ReactComponent };